// const BaseURL = "https://emsb.febinosolutions.com/";
// const BaseURL = "http://localhost:9030/"
const BaseURL = "https://emsb.univa.cloud/"
// const BaseURL = "https://bradken.univa.cloud/djan/"

// const BaseURL = "http://"+window.location.hostname+"/djan/"

export default BaseURL;
